export default __webpack_public_path__ + "static/media/rtl_testimonials.3c8575bb.png";